export const OnChangeScreen = (game: any) => {
  let isLandscape: any = screen.orientation.type.includes("landscape");
  let rotateAlert: any = document.getElementById("landscape-warning");
  if (isLandscape) {
    game.isPaused = false;
    if (rotateAlert.classList.contains("flex")) {
      rotateAlert.classList.replace("flex", "hidden");
    } else {
      rotateAlert.classList.add("hidden");
    }
  } else {
    game.isPaused = true;
    if (rotateAlert.classList.contains("hidden")) {
      rotateAlert.classList.replace("hidden", "flex");
    } else {
      rotateAlert.classList.add("flex");
    }
  }
};

export let _orientation =
  screen.orientation || screen.mozOrientation || screen.msOrientation;

export const addlistener = () => {
  _orientation.addEventListener("change", function () {
    OnChangeScreen();
  });
  window.addEventListener("resize", function () {
    OnChangeScreen();
  });
};
